import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, IconButton, InputAdornment, Menu, MenuItem, Modal, Paper, Select, Switch, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TitleText from './TitleText'
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import ButtonStyled from './ButtonStyled';
import { getProductsAll, productsUpdate } from '../services/productService';
import { useSnackbar } from 'notistack';
import { getCharacteristicAll, getCharacteristicById, getCharacteristicByIdList } from '../services/characteristics';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SwitchCustom from './inputs/SwitchCustom';


const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {xs: '81.4%', md: '83.9%', lg: '62.5%'},
    bgcolor: 'background.paper',
    borderRadius: '0.25rem',
    boxShadow: 24,
    pt: '1.125rem',
    pb: '2.5rem',
    flexGrow: 1,
    '&:focus-visible': { outline: 0},
};

const formLabelStyle = {color: '#A1A1A1', fontWeight:'bold', fontSize:{xs: '1rem',}, display: 'flex', pb:'0.6rem' };
const inputStyle = {sx: { fontSize:{xs: '1rem', md: '1rem'} }};
const missingColor = '#e31212ff'


const ActionsButton = ({onDelete, rowItem, isLoading}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <IconButton sx={{ padding: 0 }} onClick={(e) => {
            e.stopPropagation();
            onDelete(rowItem);
        }}
        disabled={isLoading}
        >
          <DeleteOutlineOutlinedIcon style={{ fontSize: {lg:'1.5rem'}, color: 'red'}} />
        </IconButton>
      </Box>
    </>
  )
}


function CharacteristicAssignmentModal({
    itemToEdit,
    onConfirmed, 
    openModal, 
    onCloseModal,
    showCharacteristicIcons
}) {

    const defaultErrorValues = {
        baseProductError: false,
        characteristicsError: false,
    };

    const { enqueueSnackbar } = useSnackbar();

    const [productCharacteristicForm, setProductCharacteristicForm] = useState({
        productId: "",
        characteristics: []
    })

    // const [baseProducts, setBaseProducts] = useState([])
    const [errors, setErrors] = useState(defaultErrorValues);

    // const [duplicateError, setDuplicateError] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const [characteristicsAvailable, setCharacteristicsAvailable] = useState([])
    const [primaryCharacteristic, setPrimaryCharacteristic] = useState(null)

    const [selectedCharacteristic, setSelectedCharacteristic] = useState("")

    const { productId, characteristics } = productCharacteristicForm

    const [variantNameError, setVariantNameError] = useState(false)

    useEffect(() => {
        const init = async () => {
            if (itemToEdit) await preSetForm();

            // await loadBaseProducts()
            await loadCharacteristicsList()
        }
        
        init()
    }, [])

    const preSetForm = async () =>{
        if (!itemToEdit || isLoading) return

        if (itemToEdit.characteristics?.length === 0) {
            enqueueSnackbar("Asigna una característica principal.", {
                variant: 'warning'
            });
            onCloseModal()
            return
        }

        setIsLoading(true)

        try {
            console.log("ITEM TO EDIT", itemToEdit)
            
            // Extract and set primary characteristic FIRST (before any early returns)
            const primaryChar = itemToEdit.characteristics.find(char => char.primary);
            if (primaryChar) {
                console.log("SETTING PRIMARY CHARACTERISTIC", primaryChar)
                setPrimaryCharacteristic(primaryChar)
            }

            // Map list of characteristicIds (secondary characteristics only)
            const assignedCharacteristicIds = itemToEdit.characteristics.filter(char => !char.primary).map(char => char.characteristicId);
            console.log("ASSIGNED CHARACTERISTIC IDS", assignedCharacteristicIds);

            // If there are no secondary characteristics, just set the form with primary only
            if (assignedCharacteristicIds.length === 0) {
                setProductCharacteristicForm({
                    ...itemToEdit,
                    characteristics: primaryChar ? [primaryChar] : []
                });
                setIsLoading(false)
                return
            }

            const characteristicsMetadataResponse = await getCharacteristicByIdList(assignedCharacteristicIds);
            console.log("CHARACTERISTICS METADATA RESPONSE", characteristicsMetadataResponse);

            if (!characteristicsMetadataResponse.Characteristics) {
                setProductCharacteristicForm({
                    ...itemToEdit,
                    characteristics: primaryChar ? [primaryChar] : []
                });
                setIsLoading(false)
                enqueueSnackbar("No se encontraron características secundarias asignadas.", {
                    variant: 'info'
                });
                return
            }

            const characteristicsMetadata = itemToEdit.characteristics.map(char => {
                console.log("CHAR", char)

                if (!!char.primary) {
                    return char
                }

                let fullCharData = characteristicsMetadataResponse.Characteristics.find(c => c._id === char.characteristicId)
                const values = (fullCharData?.values || []).map((val) => ({
                    ...val,
                    enabled: !!char.values?.find((v) => {
                        // console.log("CHAR VAL", v); 
                        return v?.valueName === val?.valueName
                    }) // !!char.value?.som
                }))

                return {
                    ...fullCharData,
                    values: values
                }
            })

            // console.log("CHARACTERISTICS METADATA", characteristicsMetadata)
            let others = characteristicsMetadata.filter(c => !c.primary)
                .map((c, idx) => ({ ...c, orderId: idx }));

            setProductCharacteristicForm({
                ...itemToEdit,
                characteristics: primaryChar ? [primaryChar, ...others] : others
            });
        } catch (error) {
            console.error('Error loading characteristics:', error);
            setIsLoading(false)
            enqueueSnackbar("Error al cargar las características.", {
                variant: 'error'
            });
        } finally {
            setIsLoading(false)
        }
    };

    /* const loadBaseProducts = async () => {
        try {
            const result = await getProductsAll();

            if (Object.keys(result).length > 0) {
                setBaseProducts(result.items);
            }
        } catch (error) {
            console.error('Error loading base products:', error);
        }
    }; */

    const loadCharacteristicsList = async() => {
        try {
            const result = await getCharacteristicAll();

            if (Object.keys(result).length > 0) {
                setCharacteristicsAvailable(result.items);
            }
        } catch (error) {
            console.error('Error loading characteristics:', error);
        }
    }

    const loadCharacteristicToAdd = async() => {
        try {
            const result = await getCharacteristicById(selectedCharacteristic);
            return result.Characteristic
        } catch (error) {
            console.error('Error loading base products:', error);
        }
    }


    const handleAddCharacteristic = async () => {
        // console.log("Adding characteristic")
        if (!selectedCharacteristic) {
            enqueueSnackbar("Debes seleccionar una  característica antes de presionar e botón de agregar.", {
                variant: 'warning'
            });
            return
        }

        if (isLoading) return

        setIsLoading(true)
        const newValue = characteristicsAvailable.find((item) => item._id === selectedCharacteristic)
        if (!newValue) {
            // console.log("Characteristic not found.")
            setIsLoading(false)
            return
        }

        const exists = characteristics.some((item) => item.characteristicId === selectedCharacteristic)
        if (exists) {
            enqueueSnackbar("Esta característica ya esta en la lista.", {
                variant: 'warning'
            });
            setIsLoading(false)
            return
        }
        
        let newCharacteristic = await loadCharacteristicToAdd()

        newCharacteristic = {
            ...newCharacteristic,
            characteristicId: newCharacteristic._id,
            values: newCharacteristic.values.map((val) => ({
                ...val,
                enabled: false, // Controlled bya switches
                priceExtra: 0.0 // Modificador de precio
            }))
        }

        setProductCharacteristicForm((prev) => {
            return {
                ...prev,
                characteristics: [
                    ...prev.characteristics,
                    newCharacteristic
                ]
            }
        })

        setIsLoading(false)
    }

    // Function to change order of characteristics by reordering the array
    const handleReorderCharacteristic = (target, direction) => {
        // console.log("Reordering characteristic", target, direction)
        setProductCharacteristicForm(prev => {
            if (!prev.characteristics || prev.characteristics.length === 0) return prev;
    
            // Separate primary characteristic
            const primaryChar = prev.characteristics.find(c => c.primary);
            const otherChars = prev.characteristics.filter(c => !c.primary);
    
            const currentIndex = otherChars.findIndex(c => c._id === target._id);
            if (currentIndex === -1) return prev;
    
            let targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
            if (targetIndex < 0 || targetIndex >= otherChars.length) return prev;
    
            // Swap elements
            [otherChars[currentIndex], otherChars[targetIndex]] = [otherChars[targetIndex], otherChars[currentIndex]];

            // console.log("Final other chars", otherChars)
            return {
                ...prev,
                characteristics: primaryChar ? [primaryChar, ...otherChars] : otherChars
            };
        });
    };
    
    
    const handleRemoveCharacteristic = (e) => {
        // console.log("Removing characteristic")
        try {
            const updatedCharacteristics = characteristics.filter((item) => item._id !== e._id)
            setProductCharacteristicForm((prev) => ({
                ...prev,
                characteristics: updatedCharacteristics
            }))

            // console.log(productCharacteristicForm)
        } catch (e) {
            console.error("Error eliminando caracteristica.", e)
        }
    }

    const handleToggleValue = (characteristicId, target) => {
        // console.log("Toggling value")
        setProductCharacteristicForm((prev) => {
            const updatedCharacteristics = prev.characteristics.map((char) => {
                if (char.characteristicId !== characteristicId) return char

                const updatedValues = char.values.map((val) => {
                    if (val.valueName !== target.valueName) return val;
                    return {
                        ...val,
                        enabled: !val.enabled
                    }
                })
                return {
                    ...char,
                    values: updatedValues
                }
            })

            return {
                ...prev,
                characteristics: updatedCharacteristics
            }
        })
    }

    const validateForm = () => {        
        setVariantNameError(!variantNameError);

        if (!primaryCharacteristic) {
            enqueueSnackbar(`Debe existir una característica principal asignada al producto.`, {
                variant: 'error'
            });
            return false;
        }

        if (characteristics.length < 1) {
            enqueueSnackbar(`Agrega al menos una característica.`, {
                variant: 'error'
            });
            return false;
        }

        for (let char of characteristics) {
            let hasEnabled = false

            for (let val of char.values) {
                if (val.enabled) {
                    hasEnabled = true
                    break
                }
            }

            if (!hasEnabled && !char.primary) {
                enqueueSnackbar(`Habilita al menos 1 valor por característica.`, {
                    variant: 'error'
                });
                return false;
            }
        }
        return true;
    };

    // Generate default variant matrix for table
    function generateDefaultMatrix({
        existingMatrix = [],
        processedCharacteristics = [],
        primaryCharacteristic
    }) {
        console.log(primaryCharacteristic)

        // Guard against null/undefined primaryCharacteristic
        if (!primaryCharacteristic) {
            console.error("generateDefaultMatrix: primaryCharacteristic is null or undefined");
            return [];
        }

        // Build a fast lookup for existing rows by primary value code
        const existingMap = new Map(
            existingMatrix.map(row => [row.primaryValueCode || row.primaryValueName, row])
        );
      
        // Build secondary list
        const secondaries = processedCharacteristics.filter(ch => !ch.primary);
      
        return (primaryCharacteristic.values || []).map(primaryVal => {
            const key = primaryVal.code || primaryVal.valueName;
            const existingRow = existingMap.get(key);
        
            // Build secondary characteristics while preserving existing values
            const newCharacteristics = secondaries.map(ch => {
                const existingChar = existingRow?.characteristics.find(
                    ec => ec.characteristicId === ch.characteristicId
                );
        
                const valueMap = new Map(
                    (existingChar?.values || []).map(v => [v.code, v])
                );
        
                return {
                    characteristicId: ch.characteristicId,
                    characteristicName: ch.characteristicName,
                    characteristicCategory: ch.characteristicCategory,
                    code: ch.code,
                    values: (ch.values || []).map(v => {
                        const existingVal = valueMap.get(v.code);
                        return {
                        valueName: v.valueName,
                        code: v.code,
                        enabled: existingVal?.enabled ?? true,
                        price_modifier: existingVal?.price_modifier ?? 0,
                        weight_modifier: existingVal?.weight_modifier ?? 0,
                        width: existingVal?.width ?? 0,
                        height: existingVal?.height ?? 0,
                        depth: existingVal?.depth ?? 0,
                        };
                    }),
                };
            });
        
            return {
                primaryValueName: primaryVal.valueName,
                primaryValueCode: primaryVal.code,
                // keep existing row-level modifiers or default
                price_modifier: existingRow?.price_modifier ?? 0,
                weight_modifier: existingRow?.weight_modifier ?? 0,
                width: existingRow?.width ?? 0,
                height: existingRow?.height ?? 0,
                depth: existingRow?.depth ?? 0,
                characteristics: newCharacteristics,
            };
        });
    }

    const onSubmitForm = async (e) => {
        if(isLoading){
            return;
        }
    
        if(!validateForm()){
            return;
        }

        setIsLoading(true)

        try {
            // Process form
            const _processedCharacteristics = productCharacteristicForm.characteristics
                .filter(char => !char.primary)
                .map((it, index) => ({
                    characteristicName: it.characteristicName,
                    characteristicId: it._id,
                    characteristicCategory: it.characteristicCategory,
                    code: it.code,
                    values: (it.values || []).filter(val => it?.primary ? true : val.enabled === true).map(val => ({
                        valueName: val.valueName, 
                        code: val.code,
                    })),
                    primary: false
                }
            ))
            console.log("PROCESSED CHARACTERISTICS", _processedCharacteristics)

            const defaultMatrix = generateDefaultMatrix({
                existingMatrix: productCharacteristicForm.variantMatrix,
                processedCharacteristics: _processedCharacteristics,
                primaryCharacteristic: primaryCharacteristic
            })

            console.log("DEFAULT MATRIX", defaultMatrix)

            // Add primary characteristic to the form
            const mergedCharacteristics = [primaryCharacteristic, ..._processedCharacteristics]

            const payload = {
                ...productCharacteristicForm,
                characteristics: mergedCharacteristics,
                primaryCharacteristic: primaryCharacteristic,
                variantMatrix: defaultMatrix
            }

            setProductCharacteristicForm(payload)

            console.log("PAYLOAD", payload)
            // Set processed characteristics in form
            const resp = await productsUpdate(payload)

            // console.log("RESP", resp)
            setIsLoading(false)

            if (resp.result) {
                enqueueSnackbar("Guardado Exitoso.", {
                    variant: 'success',
                    style: { 
                        backgroundColor: '#FC581F',
                        Width: '100%',
                        justifyContent: 'center'
                    }
                });
                onConfirmed()
                onCloseModal()
            } else {
                console.error("Error inserting characteristics", resp)
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false)
            enqueueSnackbar("Error al guardar las características.", {
                variant: 'error'
            });
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            disableEscapeKeyDown
            slotProps={{backdrop: {onClick: null}}}
            open={openModal}
            onClose={onCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
                backdropFilter: 'blur(2px)',
                BackdropProps:{
                onClick: null
                },
                '& .MuiModal-backdrop': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
                },
            }}
        >
            <Box sx={{ maxHeight: "900px", overflowY: "scroll", ...styleModal}}>
                <Box sx={{display: 'flex', justifyContent: "flex-end", width:'100%', px: '1.25rem' }}>
                    <IconButton sx={{ padding: 0}} onClick={onCloseModal}>
                        <CancelIcon sx={{color: '#FC581F', fontSize:'1.8rem'}}/>
                    </IconButton>
                </Box>
                <Box sx={{ display:'flex', flexDirection: 'column', px: {xs: '1.25rem', md:'3.125rem'}, gap:'2.5rem' }}>
                    <TitleText title={"ASIGNACIÓN DE CARACTERÍSTICAS"} customStyle={{ py: 0 }}/>

                    <FormGroup>
                        <FormLabel sx={formLabelStyle}>
                            PRODUCTO BASE
                        </FormLabel>
                        <TextField 
                            disabled
                            value={itemToEdit.productName}
                        />
                    </FormGroup>

                    <FormGroup>
                    <Box sx={{ width: '100%' }}>
                        <FormLabel sx={formLabelStyle}>
                            SELECCIONAR CARACTERÍSTICAS PARA PRODUCTO BASE
                        </FormLabel>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Select 
                                name="selectedCharacteristic" 
                                fullWidth sx={{ flexGrow: 1 }}
                                placeholder='Seleccione una característica'
                                value={selectedCharacteristic}
                                onChange={(e) => setSelectedCharacteristic(e.target.value)}
                            >
                                {
                                    characteristicsAvailable && 
                                    characteristicsAvailable.filter(item => 
                                        !characteristics.some(c => c._id === item._id)
                                    ).map((item, index) => (
                                    <MenuItem key={index} value={item._id}>{item.characteristicName}</MenuItem>
                                ))}
                            </Select>
                            <IconButton
                                sx={{
                                color: '#FC581F',
                                ml: 2,
                                boxShadow:
                                    '1px 1px 4px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)',
                                }}
                                onClick={handleAddCharacteristic}
                                disabled={isLoading}
                            >
                                <AddIcon sx={{ fontSize: '1.5rem !important' }} />
                            </IconButton>
                        </Box>
                    </Box>
                    </FormGroup>

                    <FormGroup>
                        <FormLabel>SELECCIONA LOS VALORES QUE APLICAN A LAS CARACTEÍSTICAS</FormLabel>
                        <Box
                            sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center", // centers children horizontally
                            paddingY: "1rem",
                            paddingX: "0.25rem",
                            gap: 2,
                            maxHeight: "600px",
                            overflowY: "scroll",
                            }}
                        >
                            {characteristics &&
                                characteristics
                                .filter(c => !c.primary)
                                .map((item, index) => (
                                    <Box key={index}
                                        sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}
                                    >
                                        <Box
                                            sx={{ display: "flex", flexDirection: "column", gap: 2}}
                                        >
                                            <IconButton sx={{ padding: 0}} onClick={() => handleReorderCharacteristic(item, 'up')}>
                                                <ArrowDropUpIcon sx={{color: '#A1A1A1', fontSize:'1.8rem'}}/>
                                            </IconButton>
                                            <IconButton sx={{ padding: 0}} onClick={() => handleReorderCharacteristic(item, 'down')}>
                                                <ArrowDropDownIcon sx={{color: '#A1A1A1', fontSize:'1.8rem'}}/>
                                            </IconButton>
                                        </Box>
                                        <Accordion sx={{ width: "100%" }}>
                                            <AccordionSummary
                                                expandIcon={<ArrowDownwardIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                        paddingRight: "1rem"
                                                    }}
                                                >
                                                    <Box
                                                        sx={{ display: "flex", flexDirection: "row", gap: 2 }}
                                                    >
                                                        <Typography component="span">{item?.characteristicName}</Typography>
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            gap: 2
                                                        }}
                                                    >
                                                        {showCharacteristicIcons(item)}
                                                        <ActionsButton 
                                                            onDelete={handleRemoveCharacteristic}
                                                            rowItem={item}
                                                            isLoading={isLoading}
                                                        />
                                                    </Box>
                                                </Box>
                                                
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        maxHeight: "600%",
                                                        width: "100%",
                                                        gap: "1rem"
                                                    }}
                                                >
                                                    {
                                                        item.values && item.values.map((val, valueIndex) => (
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    width: "100%",
                                                                }}
                                                                key={valueIndex}
                                                            >
                                                                <FormControlLabel 
                                                                    control={<SwitchCustom />} 
                                                                    label={val.valueName}
                                                                    checked={val.enabled}
                                                                    onChange={() => {handleToggleValue(item.characteristicId, val)}}
                                                                />
                                                            </Box>
                                                        ))
                                                    }
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Box>
                                ))
                            }
                        </Box>
                    </FormGroup>
                    <Box sx={{width:'100%', display:'flex', justifyContent: 'space-between', gap: {xs: '1.14rem', md:'2.21rem', lg: '2.57rem'} }}>
                        <ButtonStyled text={'CANCELAR'} isDisabled={isLoading} primary={false} customStyle={{ width:'100%' }} handleClick={onCloseModal}/>
                        <ButtonStyled text={'GUARDAR'} isDisabled={isLoading} customStyle={{ width:'100%' }} handleClick={onSubmitForm }/>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

export default CharacteristicAssignmentModal